import Vue from 'vue';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, {
  size: 'small'
});

// ElementUI.Tooltip.props.openDelay.default = 1000;

Vue.prototype.$elconfirm = Vue.prototype.$confirm;

Vue.use(Antd);

import App from './App';
import router from './router';
import axios from './utils/request';
import i18n from './i18n/index';
import store from './store';

import './utils/permission.js';

import 'normalize.css/normalize.css';

import './styles/index.scss';

import './icons/index.js';

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

import tool from './tool.js';
Vue.prototype.$tool = tool;

import api from '@/api/modules/index';
Vue.prototype.$api = api;

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

Vue.prototype.oss_url = 'https://daojuji.oss-cn-hangzhou.aliyuncs.com/zky/pc/';

import VueSeamlessScroll from 'vue-seamless-scroll';
Vue.use(VueSeamlessScroll);

if (!localStorage.getItem('ipp_lang')) localStorage.setItem('ipp_lang', 'zh');

import VideoPlayer from 'vue-video-player';
Vue.use(VideoPlayer);

require('vue-video-player/src/custom-theme.css');
require('video.js/dist/video-js.css');
require('@/styles/video.css');

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});
